import { useContext } from "react";
import ImagePickerContext from "../ImagePickerContext";
import useBaseComponent from "../MultiImagePicker/useComponent";

const useComponent = () => {
    const viewModel = useBaseComponent();
    const context = useContext(ImagePickerContext) || {};
    const imageCount = Array.isArray(viewModel.fileList) ? viewModel.fileList.length : 0;

    return {
        ...viewModel,
        buttonSize: context.buttonSize || "small",
        buttonStyle: context.buttonStyle || { borderRadius: 999 },
        counterTextStyle: context.counterTextStyle || { fontSize: 12 },
        imageCount,
    };
};

export default useComponent;